import { useQuery } from "react-query";
import {
  getMyCancelledCustomizedOrders,
  getMyCustomizedOrders,
} from "../../actions/my-orders/services";
import MyOrdersTable from "./MyOrdersTable";

const columns: string[] = [
  "Reference",
  "Products count",
  "Sent Date",
  "Progress",
  "Order details",
];
const cancelledColumns: string[] = ["Product Name", "Delete Date", "Actions"];

export default function CustomizedOrders({
  orderType,
  url,
  orderStatus,
  selectedDate,
}: {
  orderType: string;
  url: string;
  orderStatus: string;
  selectedDate: any;
}) {
  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ["my_direct_orders", orderStatus, selectedDate],
    orderStatus === "cancelled"
      ? () => getMyCancelledCustomizedOrders(selectedDate)
      : () => getMyCustomizedOrders(selectedDate),
    {
      keepPreviousData: true,
    }
  );

  if (isError) {
    return <p>Error!</p>;
  }

  return (
    <div>
      <MyOrdersTable
        columns={orderStatus === "cancelled" ? cancelledColumns : columns}
        isLoading={isLoading || isFetching}
        orderType={orderType}
        data={data?.data.data}
        orderStatus={orderStatus}
        url={url}
        refetch={refetch}
      />
    </div>
  );
}
